<template>
  <div class="products-grid">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ProductsGrid',
}
</script>

<style scoped lang="scss">
.products-grid {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  column-gap: 8px;
  row-gap: 24px;
  flex-wrap: wrap;
  padding: 10px 0;
}
</style>
